import React, { useMemo } from 'react';
import Icon from './Icon';
import { uniqueId } from 'lodash-es';
import clsx from 'clsx';

interface RatingStarsProps {
  rating?: number;
  starsCount?: number;
  showRatingText?: boolean;
  starClassName?: string;
}

const RatingStars = ({
  rating,
  starsCount = 5,
  showRatingText = true,
  starClassName,
}: RatingStarsProps) => {
  const uuid = useMemo(() => uniqueId(), []);
  const fullStarsCount = useMemo(
    () => (rating ? Math.floor(rating) : 0),
    [rating]
  );
  const hasHalfStar = useMemo(
    () => (rating ? rating % 1 !== 0 : false),
    [rating]
  );
  const onStarsClick = (e: React.MouseEvent) => {
    e.preventDefault();

    document
      .getElementById('yotpo-reviews-widget')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  const getStarName = (index: number) => {
    if (index < fullStarsCount) {
      return 'star-filled';
    } else if (index === fullStarsCount && hasHalfStar) {
      return 'star-half';
    }
    return 'star-empty';
  };

  return rating ? (
    <a
      onClick={onStarsClick}
      href="#yotpo-reviews-widget"
      className="flex items-baseline gap-0.5"
    >
      {showRatingText && (
        <span className="mr-0.5 text-md font-normal text-gray-700">
          {rating.toFixed(1)}
        </span>
      )}
      {Array.from({ length: starsCount }).map((_, idx) => (
        <Icon
          key={`${idx}-rating-star-${uuid}`}
          className={clsx(starClassName, 'h-3 w-[13px]')}
          name={getStarName(idx)}
        />
      ))}
    </a>
  ) : null;
};

export default RatingStars;
